import modelMixins from './model-mixins.js';
import AuthMixin from './auth-mixin.js';
import DashboardComponentsMixin from './dashboard-components-mixin.js';

export default {
  ...modelMixins,
  AuthMixin,
  DashboardComponentsMixin,
};
